import { ProtocolCardTitle } from './chunk-ICZCLVBK.js';
import { RELAY, RELAY_COMPONENTS, RELAY_EVENTS, pickField, RELAY_FIELDS, RELAY_LABELS, ProtocolValue, SectionCard, FactGrid, ProtocolBadge } from './chunk-BL57CTJZ.js';
import { ArrowLeftRight } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

var NOTE = "mt-2 rounded-md border border-border/60 bg-muted/30 px-2.5 py-1.5 text-2xs leading-snug text-muted-foreground";
function RelayFundsMovement({
  event,
  hint,
  chain,
  renderAddress
}) {
  const pid = hint.protocolId ?? RELAY.protocolId;
  const from = pickField(event.params, ...RELAY_FIELDS.from);
  const to = pickField(event.params, ...RELAY_FIELDS.to);
  const token = pickField(event.params, ...RELAY_FIELDS.token);
  const amount = pickField(event.params, ...RELAY_FIELDS.amount);
  const address = (v) => typeof v === "string" && renderAddress ? renderAddress(v, { chain }) : /* @__PURE__ */ jsx(ProtocolValue, { value: v });
  const facts = [
    { label: RELAY_LABELS.from, value: address(from), when: from },
    { label: RELAY_LABELS.to, value: address(to), when: to },
    { label: RELAY_LABELS.amount, value: /* @__PURE__ */ jsx(ProtocolValue, { value: amount }), when: amount },
    // The emitter: which Relay contract narrated this — the ApprovalProxy that
    // pulled the user's tokens, or the Router that paid them out.
    { label: RELAY_LABELS.movedBy, value: address(event.address), when: event.address }
  ];
  if (token) {
    facts.splice(2, 0, {
      label: "Token",
      value: address(token),
      when: token
    });
  }
  return /* @__PURE__ */ jsxs(
    SectionCard,
    {
      title: /* @__PURE__ */ jsx(ProtocolCardTitle, { protocolId: pid, icon: ArrowLeftRight, label: RELAY.displayName }),
      protocolId: pid,
      meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: pid }),
      children: [
        /* @__PURE__ */ jsx(FactGrid, { facts }),
        /* @__PURE__ */ jsx("p", { className: NOTE, children: RELAY_LABELS.restates })
      ]
    }
  );
}

// src/protocols/relay/index.ts
var PID = RELAY.protocolId;
var C = RELAY_COMPONENTS;
var RELAY_HINTS = {
  valueHints: [],
  callHints: [],
  eventHints: [
    {
      protocolId: PID,
      event: RELAY_EVENTS.fundsMovement,
      component: C.fundsMovement,
      summaryFields: []
    }
  ]
};
function registerRelay(registry) {
  registry.registerEvent(C.fundsMovement, RelayFundsMovement);
  registry.registerHints(RELAY_HINTS);
  return registry;
}

export { RELAY_HINTS, RelayFundsMovement, registerRelay };
//# sourceMappingURL=chunk-YUJI7EVD.js.map
//# sourceMappingURL=chunk-YUJI7EVD.js.map